import './tiptap_styles.scss';

import { TextStyleKit } from '@tiptap/extension-text-style';
import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import { FC, useEffect, useRef } from 'react';
import { twMerge } from 'tailwind-merge';
import { TipTapMenuBar } from './MenuBar';

const extensions = [TextStyleKit, StarterKit];

export type TipTapEditorProps = {
  id?: string;
  value?: string;
  onChange?: (html: string) => void;
  disabled?: boolean;
  className?: string;
};

const TipTapEditor: FC<TipTapEditorProps> = ({ id, value = '', onChange, disabled = false, className }) => {
  const lastSyncedValue = useRef(value);

  const editor = useEditor({
    extensions,
    content: value,
    editable: !disabled,
    autofocus: true,
    onUpdate: ({ editor: currentEditor }) => {
      const html = currentEditor.getHTML();
      lastSyncedValue.current = html;
      onChange?.(html);
    },
  });

  useEffect(() => {
    if (!editor) return;
    editor.setEditable(!disabled);
  }, [editor, disabled]);

  useEffect(() => {
    if (!editor || value === lastSyncedValue.current) return;
    lastSyncedValue.current = value;
    editor.commands.setContent(value, { emitUpdate: false });
  }, [editor, value]);

  return (
    <div
      id={id}
      className={twMerge(
        'tiptap-composer rounded-lg border border-primary-border bg-primary-background shadow-xs',
        'focus-within:outline-none focus-within:ring-2 focus-within:ring-brand-600 focus-within:ring-offset-2',
        disabled && 'pointer-events-none opacity-50',
        className
      )}
    >
      <div className='tiptap-composer__content'>
        <EditorContent editor={editor} />
      </div>
      <TipTapMenuBar editor={editor} disabled={disabled} />
    </div>
  );
};

export default TipTapEditor;
